import React from "react";
import { defineMessages } from "react-intl";
import { Box } from "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { DropzoneContentIcon } from "./DropzoneContentIcon.js";
const localized = defineMessages({
  dropzoneContentSuccessMessage: {
    id: "SDZC_message",
    defaultMessage: "File {filename} uploaded successfully"
  }
});
function DropzoneContentSuccess({ file }) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DropzoneContentIcon, { type: "success" }), /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.dropzoneContentSuccessMessage, labelParams: { filename: /* @__PURE__ */ React.createElement("b", null, file?.name ?? "") } })));
}
export {
  DropzoneContentSuccess
};
//# sourceMappingURL=DropzoneContentSuccess.js.map
